import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled, } from '@mui/material/styles';
import * as React from 'react';
// import SwipeableViews from 'react-swipeable-views';
// import { autoPlay } from 'react-swipeable-views-utils';
import { projectService } from '../../_mocks_/projectService';
import ProjectDetails from './ProjectDetails';
// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText('#10B981'),
  backgroundColor: '#10B981',
  '&:hover': {
    backgroundColor: '#10B994',
  },
}));

export default function ProjectSlider() {
  // const theme = useTheme();
  const [data] = React.useState(projectService)
  // const [activeStep, setActiveStep] = React.useState(0);
  const [counter, setCounter] = React.useState(2)
  // const maxSteps = data.length;
  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  // const handleStepChange = (step) => {
  //   setActiveStep(step);
  // };
  const loadMores = () => {
    setCounter(counter => counter + 2)
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      > */}
      {data.slice(0, counter).map((step, index) => (
        <div key={step.id}>
          {/* {Math.abs(activeStep - index) <= 5 ? ( */}
            <ProjectDetails item={step} key={step.id} />
          {/* ) : null} */}
        </div>
      ))}
      <Box textAlign='center' sx={{padding: '10px 2px', margin: '10px 0'}}>
        <ColorButton variant="contained" onClick={loadMores}>Load moore...</ColorButton>
      </Box>
      {/* </AutoPlaySwipeableViews> */}
      {/* <MobileStepper
      style={{backgroundColor: '#18042e', color: '#250630'}}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      /> */}
    </Box>
  )
}
